import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootState, RootThunkApi } from "../../../app/store";
import {
  DateRangeFieldName,
  DateRangeType,
  getDateRange,
} from "../../../compnents/form/DateSelect";
import { fromJson, StaffCostEntry } from "../../../models/peopleSales";
import * as service from "../../../services/peopleSales";
import { GetStaffCostEntriesParams } from "../../../services/peopleSales";

interface StaffCostsState {
  params: GetStaffCostEntriesParams;
}

const [timeHead, timeTail] = getDateRange(DateRangeType.ThisMonth);

const initialState = {
  params: {
    queryType: "0",
    timeHead,
    timeTail,
    [DateRangeFieldName]: DateRangeType.ThisMonth,
  },
} as StaffCostsState;

const peopleSaleSlice = createSlice({
  name: "peopleSaleSlice",
  initialState,
  reducers: {
    setGetStaffCostEntriesParam: (state, action) => {
      state.params = action.payload;
    },
  },
});

export const { setGetStaffCostEntriesParam } = peopleSaleSlice.actions;

export const selectGetStaffCostEntriesParams = (
  state: RootState
): GetStaffCostEntriesParams => state.peopleSale.params;

export const getStaffCostEntries = createAsyncThunk<
  [string, StaffCostEntry[]],
  GetStaffCostEntriesParams,
  RootThunkApi
>("peopleSales/getStaffCostEntriesStatus", async (params, api) => {
  return sendAsync(service.getpeopleSale(params), api).then(
    (data) =>
      [
        data.quickSaleSummary as string,
        _.chain(data.summaryList)
          .map((e) => fromJson(e))
          .value(),
      ] as [string, StaffCostEntry[]]
  );
});

export default peopleSaleSlice.reducer;
